module.exports = __webpack_public_path__ + "images/home-hero/doctor-patient.png";